module.exports = __webpack_public_path__ + "static/media/hub_city_consignee_mapping.9e1c3086.xlsx";